import React from 'react';
import './Footer.css';

function Footer(){
    return(
        <footer className='footer mt-5 pt-4'>
            
            <div className='footer-items d-flex justify-content-between pb-5 row'>
                <div className='about-laptops-footer col-12 col-sm-12 col-md-4 col-lg-4 mt-3 mb-3'>
                    <h4 className='footer-heading pb-3'>Welcome to <span>LaptopZone</span></h4>
                    <p>We are a world-class laptop store with 20+ top laptops available at market-competitive rates. Please contact us for any laptop/notebook you're looking for. Thank you. </p>
                </div>
                <ul className='footer-links-list col-12 col-sm-12 col-md-2 col-lg-2 mt-3 mb-3'>
                    <h4 className='footer-heading pb-2'>Navigation</h4>
                    <li><a href='#'>HOME</a></li>
                    <li><a href='#products'>PRODUCTS</a></li>
                    <li><a href='#'>CART</a></li>
                    <li><a href='#'>PRODUCTS</a></li>
                    <li><a href='#'>TOP LAPTOPS</a></li>
                </ul>
                <ul className='trending-products-list col-12 col-sm-12 col-md-2 col-lg-2 mt-3 mb-3'>
                    <h4 className='footer-heading pb-2'>Popular Items</h4>
                    <li><a href='#'>Dell Laptop</a></li>
                    <li><a href='#'>HP Laptop</a></li>
                    <li><a href='#'>Asus Laptop</a></li>
                    <li><a href='#'>Gigabyte G5</a></li>
                    <li><a href='#'>Razer Blade 14</a></li>
                    <li><a href='#'>Lenovo Legion Pro 7i</a></li>
                </ul>
                <ul className='contact-info-list col-12 col-sm-12 col-md-2 col-lg-2 mt-3 mb-3'>
                    <h4 className='footer-heading pb-2'>Contact Us</h4>
                    <li>Phone: +92384884743</li>
                    <li>Email: admin@laptops.com</li>
                    <li>Address: X street, New York</li>
                </ul>
                
                <div className='footer-icons d-flex align-content-center col-12 col-sm-12 col-md-2 col-lg-2 mt-3 mb-3'>
                    <i class="fa-brands fa-facebook-f"></i>
                    <i class="fa-brands fa-instagram"></i>
                    <i class="fa-brands fa-snapchat"></i>
                </div>
            </div>
            

            <div className='footer-copyright pt-3 pb-3 text-center'>
                <p>Made with ❤️ by Abdul Wahab</p>
            </div>
        </footer>
    )
}

export default Footer;